// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleFoundationLine_root__1KaUZ","foundationLineText":"ArticleFoundationLine_foundationLineText__k_sEk"};